import { render, staticRenderFns } from "./YioksTipHtml.vue?vue&type=template&id=45122dda&scoped=true&"
import script from "./YioksTipHtml.vue?vue&type=script&lang=js&"
export * from "./YioksTipHtml.vue?vue&type=script&lang=js&"
import style0 from "./YioksTipHtml.vue?vue&type=style&index=0&id=45122dda&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45122dda",
  null
  
)

export default component.exports